export type PageMetaData = {
  title?: string
  description?: string
  keywords?: string
  imgUrl?: string
}

/**
 * Page names for static pages.
 */
export const PAGE_NAMES = {
  home: 'home',
  games: 'games',
  players: 'players',
  teams: 'teams',
  playerStats: 'player_stats',
  teamStats: 'team_stats',
  gameStats: 'game_stats',
  playerProfile: 'player_profile',
  teamProfile: 'team_profile',
  playerTable: 'player_table',
  teamTable: 'team_table',
  playerComparison: 'player_comparison',
  advancedStats: 'advanced_stats',
  fantasy: 'fantasy',
  login: 'login',
  careerLeaders: 'career_leaders',
} as const

type PageNameValue = (typeof PAGE_NAMES)[keyof typeof PAGE_NAMES]

type PageMetadataMap = {
  [K in PageNameValue]: PageMetaData
}

/**
 * Page metadata for static pages.
 * TypeScript will error if any PAGE_NAMES value is missing from this object.
 */
export const PAGE_METADATA: PageMetadataMap = {
  [PAGE_NAMES.home]: {
    title: 'Stats Home',
    description:
      'The home forPremier Lacrosse League Scores, Standings, Player Stats, Team Stats, and Game Stats',
    keywords: 'PLL, stats, team stats, player stats, game stats',
  },
  [PAGE_NAMES.games]: {
    title: 'Games',
    description: 'Premier Lacrosse League game schedule and results',
    keywords:
      'PLL, game schedule, game results, game stats, scores, boxscore, gamecast, live stats',
  },
  [PAGE_NAMES.players]: {
    title: 'Players Stats Leaders',
    description:
      'Premier Lacrosse League player stat leaders for goals, assists, points, shots, and more.',
    keywords: 'PLL, player stats, player stats, player stats',
  },
  [PAGE_NAMES.teams]: {
    title: 'Teams Stats Leaders',
    description: 'Premier Lacrosse League team stat leaders',
    keywords: 'PLL, team stat leaders, team stats, team stats, team stats',
  },
  [PAGE_NAMES.playerStats]: {
    title: 'All Player Stats',
    description: 'Premier Lacrosse League player stats table for all players',
    keywords: 'PLL, player stats, player stats, player stats',
  },
  [PAGE_NAMES.teamStats]: {
    title: 'All Team Stats',
    description: 'Premier Lacrosse League team stats table for all teams',
    keywords: 'PLL, team stats, team stats, team stats',
  },
  [PAGE_NAMES.advancedStats]: {
    title: 'Advanced Stats',
    description:
      'The Premier lacrosse League Advanced Stats Labs. Explore cutting edge advanced stats to better understand player and team skillsets.',
    keywords: 'PLL, advanced stats, lacrosse stats, touches, goal rate',
  },
  [PAGE_NAMES.careerLeaders]: {
    title: 'Career Leaders',
    description:
      'The all time career leaders for pro lacrosse. View career leaders in points, assists, faceoffs, and more.',
    keywords:
      'PLL, career leaders, career points, career assists, career faceoffs, career goals',
  },
  [PAGE_NAMES.playerComparison]: {
    title: 'Player Comparison',
    description:
      'Compare players career and season stats in points, assists, faceoffs, and more.',
    keywords: 'PLL, compare players,career comparison, season comparison',
  },
  [PAGE_NAMES.gameStats]: {
    title: 'Game Stats',
    description: 'Premier Lacrosse League game statistics and box scores',
    keywords: 'PLL, game stats, box score, game statistics',
  },
  [PAGE_NAMES.playerProfile]: {
    title: 'Player Profile',
    description: 'Premier Lacrosse League player profile and statistics',
    keywords: 'PLL, player profile, player stats, player information',
  },
  [PAGE_NAMES.teamProfile]: {
    title: 'Team Profile',
    description: 'Premier Lacrosse League team profile and statistics',
    keywords: 'PLL, team profile, team stats, team information',
  },
  [PAGE_NAMES.playerTable]: {
    title: 'Player Stats Table',
    description: 'Premier Lacrosse League player statistics table',
    keywords: 'PLL, player stats table, player statistics',
  },
  [PAGE_NAMES.teamTable]: {
    title: 'Team Stats Table',
    description: 'Premier Lacrosse League team statistics table',
    keywords: 'PLL, team stats table, team statistics',
  },
  [PAGE_NAMES.fantasy]: {
    title: 'Fantasy',
    description: 'Premier Lacrosse League fantasy lacrosse',
    keywords: 'PLL, fantasy lacrosse, fantasy stats',
  },
  [PAGE_NAMES.login]: {
    title: 'Login',
    description: 'Login to Premier Lacrosse League',
    keywords: 'PLL, login, sign in, sign up',
  },
}
